// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"24":"tkdetail","776":"tklist"}[chunkId] + "." + {"24":"8c4abc6e","776":"c9ed7e9e"}[chunkId] + ".js";
};